<template>
  <div class="w-80 border-t-4 border-light-purple p-4 rounded-lg bg-pure-white relative">
    <div class="space-y-2">
      <div class="h-4 w-16 rounded-full bg-grey-200" />
      <div class="h-4 w-64 rounded-full bg-grey-200" />
      <div class="h-4 w-48 rounded-full bg-grey-200" />
    </div>
    <div class="py-8 space-y-4">
      <div class="flex items-center justify-center content-center flex-wrap gap-x-2 gap-y-3 h-84">
        <div
          v-for="prompt in promptGetBoxes()"
          :key="prompt.id"
          class="space-y-1"
        >
          <div
            class="relative rounded-3xl w-20 h-20 flex-shrink-0 flex items-center justify-center border"
            :style="{
              backgroundColor: promptColors[prompt.color].primaryColor,
              borderColor: promptColors[prompt.color].secondaryColor,
              color: promptColors[prompt.color].textColor
            }"
          >
            <div class="text-xs absolute top-0">{{ prompt.abbreviation }}</div>
            <div class="text-5xl font-bold">+</div>
          </div>
          <div
            class="w-20 h-5 flex items-center justify-center border border-grey-200 rounded"
          >
            <div class="w-6 h-1 rounded bg-grey-200 flex-shrink-0" />
          </div>
        </div>
      </div>
      <div
        v-if="promptPageCount > 1"
        class="flex gap-2 items-center justify-center"
      >
        <button
          v-for="n in promptPageCount"
          :key="n"
          :class="n - 1 === promptPageIndex ? 'bg-light-purple' : ''"
          class="w-2 h-2 rounded-full border border-light-purple outline-none"
          @click.prevent="promptPageIndex = n - 1"
        />
      </div>
    </div>
    <BlInputButton
      v-if="promptPageCount > 1"
      class="absolute rounded-full border border-light-purple"
      :style="{ top: '50%', left: '-4rem', transform: 'translate(0, -50%)' }"
      icon="chevron-left"
      type="plain"
      :disabled="promptPageIndex === 0"
      @clicked="promptPageIndex--"
    />
    <BlInputButton
      v-if="promptPageCount > 1"
      class="absolute rounded-full border border-light-purple"
      :style="{ top: '50%', right: '-4rem', transform: 'translate(0, -50%)' }"
      icon="chevron-right"
      type="plain"
      :disabled="promptPageIndex === promptPageCount - 1"
      @clicked="promptPageIndex++"
    />
  </div>
</template>

<script>
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "RepositoryPromptingPreview",
  components: { BlInputButton },
  props: ["prompts"],
  data() {
    return {
      promptPageIndex: 0,
      promptColors: {
        cherry: {
          primaryColor: "#FF4447",
          secondaryColor: "#FF4447",
          textColor: "#FFFFFF"
        },
        blush: {
          primaryColor: "#FFC1C2",
          secondaryColor: "#FF4447",
          textColor: "#FF4447"
        },
        gold: {
          primaryColor: "#F4D430",
          secondaryColor: "#F4D430",
          textColor: "#FFFFFF"
        },
        daffodil: {
          primaryColor: "#FBEEAC",
          secondaryColor: "#F4D430",
          textColor: "#9B7600"
        },
        lake: {
          primaryColor: "#2AB1A8",
          secondaryColor: "#2AB1A8",
          textColor: "#FFFFFF"
        },
        mint: {
          primaryColor: "#B8E5E2",
          secondaryColor: "#2AB1A8",
          textColor: "#2AB1A8"
        },
        sky: {
          primaryColor: "#487ADF",
          secondaryColor: "#487ADF",
          textColor: "#FFFFFF"
        },
        hydrangeas: {
          primaryColor: "#D3DFF7",
          secondaryColor: "#487ADF",
          textColor: "#487ADF"
        },
        grey: {
          primaryColor: "#E4E4E4",
          secondaryColor: "#A0A0A0",
          textColor: "#A0A0A0"
        },
        primary: {
          primaryColor: "#9A8AC2",
          secondaryColor: "#9A8AC2",
          textColor: "#FFFFFF"
        }
      }
    };
  },
  computed: {
    promptPageLimit() {
      return 9;
    },
    promptPageCount() {
      const totalBoxes = this.prompts.length;
      return Math.ceil(totalBoxes / this.promptPageLimit);
    }
  },
  mounted() {
    this.promptPageIndex = 0;
  },
  methods: {
    promptGetBoxes() {
      const start = this.promptPageIndex * this.promptPageLimit;
      const end = (this.promptPageIndex + 1) * this.promptPageLimit;
      return this.prompts.slice(start, end);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/prompting/Preview.vue